import sessionstorage from "sessionstorage"

// Lists are reused while the visitor browses, but fetched again after this long so new files show up.
const MAX_AGE_MS = 5 * 60 * 1000

export const getCached = key => {
  const cached = sessionstorage.getItem(key)
  if (!cached) return null
  try {
    const { savedAt, data } = JSON.parse(cached)
    if (savedAt && Date.now() - savedAt < MAX_AGE_MS) return data
  } catch (error) {}
  return null
}

export const setCached = (key, data) => {
  sessionstorage.setItem(key, JSON.stringify({ savedAt: Date.now(), data }))
}
